import React, { Component } from 'react';
import Button from '../../../../../components/Button';
import Img from '../../../../../components/Img/Img';
import Panel from '../../../../../components/outline/Panel';
import Anchor from '../../../../../components/link/Anchor';
import TableTransfer from '../../../../../components/input/TableTransfer';
import ExcelUploadForm from '../../../../../components/form/ExcelUploadForm';
import {
  TAG_TREND_KEYWORD_MANAGEMENT_PAGE_PANEL_NAME,
  TAG_TREND_KEYWORD_SECTION_TYPE,
} from '../../../../../constants/service/app/tagConstants';
import { TAG_UPLOAD_TEMPLATE_XLSX_URL } from '../../../../../constants/service/common/staticFileUrlConstants';
import { comparePrePropsAndNextProps } from '../../../../../lib/common';
import tagTrendKeywordStyleInfo from '../../../../../static/images/tag/tagTrendKeyword/tag-trend-keyword-style-info.png';
import { columns } from './columns';
import './TagManagementTrendKeywordStyleList.scss';

class TagManagementTrendKeywordStyleList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps, nextState) => {
    return comparePrePropsAndNextProps([
      [nextProps, this.props],
      [nextState, this.state],
    ]);
  };

  render() {
    const {
      onSubmit,
      recommendTagStyleList,
      selectTrendKeywordMainContentsList,
      getRelatedTagList,
      onDragEndSelectTagTrendKeywordContentsList,
      getTagTrendKeywordContentsList,
      getTagTrendKeywordAllListExcelDownload,
      getTagTrendKeywordSelectedListExcelDownload,
      setTagTrendKeywordExcelUpload,
    } = this.props;
    const { itemList, selectedItemList } = recommendTagStyleList;

    return (
      <Panel
        name={TAG_TREND_KEYWORD_MANAGEMENT_PAGE_PANEL_NAME[TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST]}
        className="tag-management-trend-keyword-style-list"
      >
        <div className="panel-header">
          <div className="title">스타일별 추천 태그 리스트</div>

          <Button
            color="primary"
            isRadius={true}
            text="저장"
            onClick={() => onSubmit(TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST)}
          />
        </div>

        <div className="panel-body">
          <div className="tag-trend-keyword-info">
            <Img className="tag-trend-keyword-info-img" src={tagTrendKeywordStyleInfo} />

            <div className="help-text">
              <div>* 스타일별 추천 태그 리스트는 최소 3개에서 최대 30개까지 설정할 수 있습니다.</div>
            </div>
          </div>

          <TableTransfer
            dataSource={itemList.list}
            operations={['연결', '해제']}
            leftTitle={'선택할 태그 리스트'}
            rightTitle={'스타일별 추천 태그 리스트'}
            leftTableProps={{
              columns: (utils) =>
                columns({
                  ...utils,
                  getRelatedTagList,
                  isFilter: true,
                }),
              headInfo: (
                <div className="trend-keyword-style-tag-head right">
                  <Button
                    isRadius
                    color="light"
                    text="엑셀 다운로드"
                    onClick={() =>
                      getTagTrendKeywordAllListExcelDownload(TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST)
                    }
                  />
                </div>
              ),
              rowClassName: (record) => (record.uncheckable ? 'uncheckable' : null),
              getList: (option) =>
                getTagTrendKeywordContentsList({
                  ...option,
                  tagTrendKeywordSectionType: TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST,
                }),
              pagination: itemList.pagination,
              sortOption: itemList.sortOption,
              filterOption: itemList.filterOption,
            }}
            rightTableProps={{
              columns: (utils) =>
                columns({
                  ...utils,
                  getRelatedTagList,
                }),
              headInfo: (
                <div className="trend-keyword-style-tag-head">
                  <div className="selected-trend-keyword-style-tag-item-count">
                    선택된 아이템 개수 <span>{selectedItemList.list.length}</span>
                  </div>

                  <div className="excel-button-list">
                    <Anchor
                      text="태그 업로드 템플릿"
                      isUnderLine
                      color="primary"
                      href={TAG_UPLOAD_TEMPLATE_XLSX_URL}
                      target="_blank"
                    />

                    <ExcelUploadForm
                      onChange={(file) =>
                        setTagTrendKeywordExcelUpload(file, TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST)
                      }
                      btnText="태그 엑셀 업로드"
                    />

                    <Button
                      isRadius
                      color="light"
                      text="엑셀 다운로드"
                      onClick={() =>
                        getTagTrendKeywordSelectedListExcelDownload(
                          TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST,
                        )
                      }
                    />
                  </div>
                </div>
              ),
              list: selectedItemList.list,
              canDrag: true,
              onDragEnd: (newList) =>
                onDragEndSelectTagTrendKeywordContentsList(
                  newList.list,
                  TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST,
                ),
            }}
            onChange={(action, moveIdList) =>
              selectTrendKeywordMainContentsList(
                action,
                moveIdList,
                TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST,
              )
            }
          />
        </div>
      </Panel>
    );
  }
}

export default TagManagementTrendKeywordStyleList;
